import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image'
import React from 'react'

const MeasurImage = (props: GatsbyImageProps) => (
  <GatsbyImage backgroundColor="transparent" loading="lazy" {...props} />
)

export default MeasurImage
